import { Component, OnInit, ViewChild } from '@angular/core';
import { Services1Service } from '../services/services1.service';
import { UnityComponent } from '../unity/unity.component';

@Component({
  selector: 'app-laboratorio',
  templateUrl: './laboratorio.component.html',
  styleUrls: ['./laboratorio.component.css']
})
export class LaboratorioComponent implements OnInit {

  animationName = "Unknown";

  constructor() { }

  @ViewChild('unity', { static: true }) unity: UnityComponent;

  ngOnInit() {
    (window as any).animationChangeListener = (animationName: string) => {
      this.animationName = animationName;
    }
  }

  get unityIsLoaded(): boolean {
    return this.unity.progress === 1;
  }

  setName(): void {
    this.unity.setName();
  }
  
  get progress(): number {
    return this.unity.progress * 100;
  }

}
